export default __webpack_public_path__ + "static/media/recurring-icon22.444bcebd.png";